import React, { Component } from 'react'
import "../Pages/Profile/profile.css"


import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory, Redirect } from "react-router-dom";
import firebase from 'firebase/compat/app';
import { getAuth } from "firebase/auth";

class Logout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            isLoggedIn: false,
            redirect: false,
            redirectTo: null
        }
    }

    componentDidMount() {
        this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.setState({ user: user, isLoggedIn: true });
            } else {
                this.setState({ user: null, isLoggedIn: false });
            }
        });
    }

    componentWillUnmount() {
        this.unregisterAuthObserver();
    }

    logout = () => {
        firebase.auth().signOut();
        this.setState({ redirect: true });
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to="/" push={true} />
        }

return(
    <div><a  onClick={this.logout}>Logout</a></div>
                   
)

    }
}

export default Logout;